// =========================
// ハンバーガーメニュー
// =========================
const header = document.querySelector('.l-header');
const button = document.querySelector('.js-header-hamburger');
const closeButton = document.querySelector('.js-header-nav-close');

if (header && button) {
  const setMenuState = (isOpen) => {
    header.classList.toggle('is-open', isOpen);
    button.setAttribute('aria-expanded', String(isOpen));
  };

  button.addEventListener('click', () => {
    const isOpen = !header.classList.contains('is-open');
    setMenuState(isOpen);
  });

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      setMenuState(false);
    });
  }
}


// =========================
// トップページ MVスライダー
// =========================
const mvEl = document.querySelector('.js-top-mv-swiper');

if (mvEl) {
  const wrapper = mvEl.querySelector('.swiper-wrapper');
  const originalSlides = mvEl.querySelectorAll('.swiper-slide');
  const originalLength = originalSlides.length;

  // スライド複製（枚数少ない場合のみ）
  if (originalSlides.length < 6) {
    originalSlides.forEach((slide) => {
      wrapper.appendChild(slide.cloneNode(true));
    });
  }

  const swiper = new Swiper(mvEl, {
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 48,
    speed: 1200, // ← 通常スライド速度に変更
    allowTouchMove: true, // ← 手動操作OK
    autoplay: {
      delay: 5000,
      disableOnInteraction: false, // 操作後も自動再生を続けたい場合
    },
    pagination: {
      el: '.p-top-mv__pagination',
      clickable: true,
      renderBullet: function (index, className) {
        if (index >= originalLength) return '';
        return `<span class="${className}"></span>`;
      },
    },

    breakpoints: {
      0: { spaceBetween: 16 },
      769: { spaceBetween: 48 },
    },
  });

  // アニメーション制御
  function updateActiveSlide() {
    const slides = mvEl.querySelectorAll('.swiper-slide');

    slides.forEach((slide) => {
      slide.classList.remove('is-active');
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (activeSlide) {
      activeSlide.classList.add('is-active');
    }
  }

  // ドット制御
  function updatePagination() {
    const bullets = document.querySelectorAll('.p-top-mv__pagination .swiper-pagination-bullet');

    bullets.forEach((bullet) => {
      bullet.classList.remove('swiper-pagination-bullet-active');
    });

    const activeIndex = swiper.realIndex % originalLength;

    if (bullets[activeIndex]) {
      bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
    }
  }

  // 初期状態
  updateActiveSlide();
  updatePagination();

  // スライド変更時
  swiper.on('slideChangeTransitionStart', () => {
    updateActiveSlide();
    updatePagination();
  });
}


// =========================
// トップページ reason スライダー（ゆっくり連続）
// =========================
const reasonEl = document.querySelector('.js-top-reason-swiper');

if (reasonEl) {
  const reasonWrapper = reasonEl.querySelector('.swiper-wrapper');
  const originalSlides = reasonWrapper
    ? Array.from(reasonWrapper.querySelectorAll('.swiper-slide'))
    : [];

  // 画面が広いとスライド列全体がコンテナに収まり autoplay が進まないため、
  // 元スライド一式を複製してトラック幅を確保する（HTML は 6 枚のまま）
  if (reasonWrapper && originalSlides.length) {
    const minTrackRatio = 2;
    let guard = 0;
    while (
      reasonWrapper.scrollWidth < reasonEl.clientWidth * minTrackRatio &&
      guard < 30
    ) {
      originalSlides.forEach((slide) => {
        reasonWrapper.appendChild(slide.cloneNode(true));
      });
      guard += 1;
    }
  }

  new Swiper(reasonEl, {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 24,
    speed: 6000, // 数値を上げるほどゆっくり
    allowTouchMove: false,
    freeMode: true,
    freeModeMomentum: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: { spaceBetween: 16 },
      769: {
        spaceBetween: 24,
      },
    },
  });
}


// =========================
// 高さトランジション付きアコーディオン（flow / faq 共通）
// =========================
/**
 * @param {Element | null} root
 * @param {{
*  item: string;
*  trigger: string;
*  panel: string;
*  inner: string;
* }} sel
*/
function initHeightAccordion(root, sel) {
  if (!root) return;

  const items = root.querySelectorAll(sel.item);
  if (!items.length) return;

 // =========================
 // 初期化
 // =========================
 items.forEach((row) => {
    const trigger = row.querySelector(sel.trigger);
    const panel = row.querySelector(sel.panel);
    const inner = row.querySelector(sel.inner);

    if (!trigger || !panel || !inner) return;

    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

   // アニメーション設定（innerに対して）
    inner.style.overflow = 'hidden';
    inner.style.transition = 'height 0.4s ease';

    if (isExpanded) {
      row.classList.add('is-open');
      panel.hidden = false;
      inner.style.height = 'auto';
    } else {
      row.classList.remove('is-open');
      panel.hidden = true;
      inner.style.height = '0';
    }
  });

 // クリック処理
  items.forEach((row) => {
    const trigger = row.querySelector(sel.trigger);
    const panel = row.querySelector(sel.panel);
    const inner = row.querySelector(sel.inner);

    if (!trigger || !panel || !inner) return;

    trigger.addEventListener('click', () => {
      const isOpen = row.classList.contains('is-open');

      if (isOpen) {
       // 閉じる
        row.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');

        const currentHeight = inner.scrollHeight;
        inner.style.height = `${currentHeight}px`;
        panel.hidden = false;

        requestAnimationFrame(() => {
          inner.style.height = '0';
        });

        inner.addEventListener(
          'transitionend',
          () => {
            if (!row.classList.contains('is-open')) {
              panel.hidden = true;
            }
          },
          { once: true }
        );
      } else {
       // 開く
        row.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;

        inner.style.height = '0';

        requestAnimationFrame(() => {
          inner.style.height = `${inner.scrollHeight}px`;
        });

        inner.addEventListener(
          'transitionend',
          () => {
            if (row.classList.contains('is-open')) {
              inner.style.height = 'auto';
            }
          },
          { once: true }
        );
      }
    });
  });
}
// flow
initHeightAccordion(document.querySelector('.js-flow-accordion'), {
  item: '.p-top-flow__item',
  trigger: '.p-top-flow__trigger',
  panel: '.p-top-flow__panel',
  inner: '.p-top-flow__panel-inner',
});
// faq
initHeightAccordion(document.querySelector('.js-faq-accordion'), {
  item: '.p-top-faq__item',
  trigger: '.p-top-faq__trigger',
  panel: '.p-top-faq__panel',
  inner: '.p-top-faq__panel-inner',
});


// =========================
// アンカーリンク スムーススクロール
// =========================
(function initSmoothScroll() {
  const anchors = document.querySelectorAll('a[href*="#"]');
  if (!anchors.length) return;

  anchors.forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href') || '';
      if (!href || href === '#') return;

      const url = new URL(href, window.location.href);
      if (
        url.pathname !== window.location.pathname ||
        url.hostname !== window.location.hostname
      ) {
        return;
      }

      const targetId = decodeURIComponent(url.hash.replace('#', ''));
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();

      const headerEl = document.querySelector('.l-header');
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const targetTop =
        target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });
    });
  });
})();


// =========================
// GTranslate header switcher
// =========================
(function initHeaderLangSwitcher() {
  const links = document.querySelectorAll('.js-lang-link');
  if (!links.length) return;

  const pageLinkSwitch = document.querySelector('.js-lang-switch[data-lang-mode="page"]');
  const isContactPage =
    document.body.classList.contains('is-contact-ja') ||
    document.body.classList.contains('is-contact-en');
  const isContactPageLink = isContactPage || !!pageLinkSwitch;
  const isEnglishContactPage = document.body.classList.contains('is-contact-en');

  const clearGoogTransCookie = () => {
    const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    const hostname = window.location.hostname;

    document.cookie = `googtrans=; expires=${expires}; path=/;`;
    if (hostname) {
      document.cookie = `googtrans=; expires=${expires}; path=/; domain=${hostname};`;
      document.cookie = `googtrans=; expires=${expires}; path=/; domain=.${hostname};`;
    }
  };

  const setDocumentLang = (lang) => {
    const html = document.documentElement;
    html.lang = lang === 'en' ? 'en' : 'ja';
    html.classList.remove('translated-ltr', 'translated-rtl');
  };

  const ensureTranslateLib = () => {
    if (document.querySelector('.goog-te-combo')) return;
    if (window.gt_translate_script) return;
    if (typeof window.googleTranslateElementInit2 !== 'function') return;

    const script = document.createElement('script');
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2';
    script.async = true;
    document.body.appendChild(script);
    window.gt_translate_script = script;
  };

  const requestTranslate = (langPair, retry = 0) => {
    ensureTranslateLib();
    if (typeof window.doGTranslate === 'function') {
      window.doGTranslate(langPair);
    }

    if (!document.querySelector('.goog-te-combo') && retry < 10) {
      setTimeout(() => requestTranslate(langPair, retry + 1), 300);
    }
  };

  const getCurrentLang = () => {
    if (isContactPageLink) {
      return isEnglishContactPage ? 'en' : 'ja';
    }

    const m = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
    if (!m) return 'ja';
    const v = decodeURIComponent(m[1]); // /ja/en など
    const parts = v.split('/');
    return parts[2] || 'ja';
  };

  const syncHtmlLang = () => {
    setDocumentLang(getCurrentLang());
  };

  const syncCurrentClass = () => {
    const current = getCurrentLang();
    links.forEach((link) => {
      link.classList.toggle('is-current', link.dataset.lang === current);
    });
  };

  const syncLangUi = () => {
    syncHtmlLang();
    syncCurrentClass();
  };

  const resetContactLang = (lang) => {
    clearGoogTransCookie();
    setDocumentLang(lang);
    syncLangUi();
  };

  if (isContactPageLink) {
    resetContactLang(isEnglishContactPage ? 'en' : 'ja');

    links.forEach((link) => {
      link.addEventListener('click', () => {
        if (link.dataset.lang) {
          resetContactLang(link.dataset.lang);
        }
      });
    });
  } else {
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const hash = link.getAttribute('href') || '';
        const m = hash.match(/#googtrans\(([^|]+)\|([^)]+)\)/);

        if (m) {
          e.preventDefault();
          requestTranslate(`${m[1]}|${m[2]}`);
          setTimeout(syncLangUi, 400);
          setTimeout(syncLangUi, 900);
        }
      });
    });
  }

  syncLangUi();
})();

/**
 * Contact Form 7: 確認・完了ページへ遷移（AJAX 送信のため PHP redirect は使わない）
 */
document.addEventListener('wpcf7submit', (event) => {
  const redirect = event.detail?.apiResponse?.oohata_redirect;
  if (typeof redirect === 'string' && redirect.length > 0) {
    window.location.assign(redirect);
  }
});